<main
  class="main"
  [style]="
    data.theme === 'dark'
      ? 'background-color: #373534; color: #ffffff'
      : 'bakcgroundColor: #efecea; color: black'
  "
>
  <h2
    class="modalTitle px-3"
    *ngIf="data.cancelOrder"
    [style]="data.theme === 'dark' ? 'color: #ffffff' : 'color: black'"
  >
    {{ 'cancelRequestTitle' | i18next }}
  </h2>
  <h4
    class="modalTitle"
    mat-dialog-title
    [style]="data.theme === 'dark' ? 'color: #ffffff' : 'color: black'"
    [innerHTML]="getSafeHtml(data.text)"
  ></h4>
  <mat-dialog-content class="main--dialogContent">
    <mat-dialog-actions class="modalBtnContainer">
      <div *ngIf="!data.cancelOrder" class="modal-container--btn-container">
        <button
          class="modalBtnContainer__btn"
          *ngIf="data.redirect && !data.list"
          type="button"
          mat-dialog-close
          [routerLink]="['/login']"
        >
          {{ 'btnContinue' | i18next | uppercase }}
        </button>
        <button
          class="modalBtnContainer__btn"
          *ngIf="data.redirect && data.list && !data.manageData"
          type="button"
          (click)="onListRedirect()"
        >
          {{ 'btnContinue' | i18next | uppercase }}
        </button>
        <button
          class="modalBtnContainer__btn"
          *ngIf="data.redirect && data.list && data.manageData"
          type="button"
          (click)="onListRedirectUpdateUser()"
        >
          {{ 'btnContinue' | i18next | uppercase }}
        </button>
      </div>
      <div class="button-container" *ngIf="data.cancelOrder">
        <button
          class="modalBtnContainer__btn btn-cancel modalBtnContainer__btn-cancel"
          type="button"
          mat-dialog-close
        >
          {{ 'btnNo' | i18next | uppercase }}
        </button>
        <button
          class="modalBtnContainer__btn"
          type="button"
          (click)="confirmCancel()"
        >
          {{ 'btnYes' | i18next | uppercase }}
        </button>
      </div>
      <div *ngIf="data.close">
        <button class="modalBtnContainer__btn" type="button" mat-dialog-close>
          {{ 'btnClose' | i18next | uppercase }}
        </button>
      </div>
    </mat-dialog-actions>
    <div class="text-center spinnerContainer" [hidden]="!spinner">
      <div class="spinner-border spinner" role="status"></div>
    </div>
  </mat-dialog-content>
</main>
